export class UserType {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.userTypeName = json && json.user_type_name || null;
        this.isPlayer = json && json.is_player || null;
        this.isScout = json && json.is_scout || null;
    }

    id: number;
    userTypeName: string;
    isPlayer: boolean;
    isScout: boolean;
}